// 允许上传的图像类型
export const ALLOW_IMAGE_TYPES = ["image/jpeg", "image/png"];

// 允许上传的图像大小（字节）
export const ALLOW_IMAGE_MAX_SIZE = 10 * 1024 * 1024; // 10MB

// 允许上传的图像大小（字节）
export const ALLOW_IMAGE_MIN_SIZE = 0; // 0kb

// 允许上传的视频类型
export const ALLOW_VIDEO_TYPES = ["video/mp4", "video/quicktime", "video/mov"];

// 允许上传的视频大小（字节）
export const ALLOW_VIDEO_MAX_SIZE = 1 * 1024 * 1024 * 1024; // 1GB

// 允许上传的视频分辨率
export const ALLOW_VIDEO_MIN_RESOLUTION = 720; // 720P

// 允许上传的视频分辨率上限
export const ALLOW_VIDEO_MAX_RESOLUTION = 4096; // 4K

// 允许上传的视频时长（秒）
export const ALLOW_VIDEO_MIN_DURATION = 30; // 30秒

// 允许上传的视频时长（秒）
export const ALLOW_VIDEO_MAX_DURATION = 180; // 3分钟
